<template>
    <premade-comment :loadedPremadeComment="premadeComment" :update="true"></premade-comment>
</template>

<script>
import _ from 'lodash'
import PremadeComment from './components/PremadeComment.vue'


export default {
  name: 'premade-sentences-edit',
  components: {PremadeComment},
  data() {
        return {
            premadeComment: {premadeSentences :[], schools:[], text: '', html: '', caption: '', favorite: 1, score:1},
        }
  },
  created(){
      this.getPremadeComment(this.$route.params.id);
  },
  methods: {
    getPremadeComment(id){
        this.premadeCommentRepo.get(id).then(response => {
            this.premadeComment = response.data.data;
        });
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-comments/Edit.vue